import { SEND_EMAIL_OTP, VERIRY_EMAIL_OTP, UPDATE_MFA_TYPE} from "../actionTypes";
import { sendEmailOTP, updateMfaType, varifyEmailOtp } from "../../../api/userManagement/mfa.service";

const request = () => ({ type: SEND_EMAIL_OTP.REQUEST });
const failure = (error) => ({ type: SEND_EMAIL_OTP.FAILURE, error });
const success = (data) => ({ type: SEND_EMAIL_OTP.SUCCESS,data});

const vrifyEmailOTPRequest = () => ({ type: VERIRY_EMAIL_OTP.REQUEST });
const varifyEmailOTPFailure = (error) => ({ type: VERIRY_EMAIL_OTP.FAILURE, error });
const varifyEmailOTPSuccess = (data) => ({ type: VERIRY_EMAIL_OTP.SUCCESS,data});

// const updateMfaTypeRequest = () => ({ type: UPDATE_MFA_TYPE.REQUEST });
// const updateMfaTypeFailure = (error) => ({ type: UPDATE_MFA_TYPE.FAILURE, error });
// const updateMfaTypeSuccess = (data) => ({ type: UPDATE_MFA_TYPE.SUCCESS,data});



export const sendEmailotp= (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return sendEmailOTP(payload)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.code,status:false});
      });
  };
};

export const varifyEmailOTP= (payload) => {
    return (dispatch, getState) => {
      dispatch(vrifyEmailOTPRequest());
      return varifyEmailOtp(payload)
        .then((res) => {
          dispatch(varifyEmailOTPSuccess(res));
          return Promise.resolve({res:res,status:true,code:res?.code});
        })
        .catch((error) => {
          dispatch(varifyEmailOTPFailure(error?.message,error.code));
          return Promise.resolve({error:error?.message,status:false,code:error.code});
        });
    };
  };

//   export const updateMFAType= (payload) => {
//     return (dispatch, getState) => {
//       dispatch(updateMfaTypeRequest());
//       return updateMfaType(payload)
//         .then((res) => {
//           dispatch(updateMfaTypeSuccess(res));
//           return Promise.resolve({res:res,status:true});
//         })
//         .catch((error) => {
//           dispatch(updateMfaTypeFailure(error?.message));
//           return Promise.resolve({error:error?.message,status:false});
//         });
//     };
//   };
